import buildChoices from './buildChoices'
import { BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'

export default function choicesBuilder({ rawField }: FieldBuilderParams): Partial<BuiltFieldAttributes> {
  return {
    choices: buildChoices(rawField.choices, rawField.type !== 'SortField')
  }
}
